import { createTRPCNext } from "@chainpatrol/trpc/next";

import { getDeploymentUrl } from "./get-deployment-url";

export const trpc = createTRPCNext({
  baseUrl: getDeploymentUrl({}),
});
